/** Build workspaceIds query fragment for API routes that scope to active workspaces. */
export function workspaceScopeQueryParam(workspaceIds: string[]): string {
  if (workspaceIds.length === 0) return ''
  return `workspaceIds=${encodeURIComponent(workspaceIds.join(','))}`
}

/** Append workspace scope to a URL that may already have query params. */
export function withWorkspaceScope(url: string, workspaceIds: string[]): string {
  const scope = workspaceScopeQueryParam(workspaceIds)
  if (!scope) return url
  return url.includes('?') ? `${url}&${scope}` : `${url}?${scope}`
}
